import ImgAbout from '../../assets/sections/about.jpg';
import ImgOffer from '../../assets/sections/offer.jpg';
import ImgContact from '../../assets/sections/contact.jpg';
import Svg from '../../components/svg';

import About from '../../components/sections/about/About';
import Offer from '../../components/sections/offer/Offer';
import Gallery from '../../components/sections/gallery/Gallery';
import Contact from '../../components/sections/contact/Contact';


const Configuration = {
  companyName: 'Schody',
  title: 'Schody Drewniane',
  subtitle: 'Produkcja, sprzedaż i montaż schodów drewnianych',
  tel: {
    num: 790612083,
    text: "790 - 612 - 083",
  },
  email: '',

  sections: [
    {
      id: 'about',
      title: 'O Firmie',
      bgImage: ImgAbout,
      icon: Svg.Information,
      component: About,
    },
    {
      id: 'offer',
      title: 'Oferta',
      bgImage: ImgOffer,
      icon: Svg.HandShake,
      component: Offer,
    },
    {
      id: 'gallery',
      title: 'Galeria',
      bgImage: ImgOffer,
      icon: Svg.Gallery,
      component: Gallery,
    },
    {
      id: 'contact',
      title: 'Kontakt',
      bgImage: ImgContact,
      icon: Svg.Call,
      component: Contact,
    },
  ]
};

export default Configuration;
